import {webFont, textBlack, primaryColor, fontColor} from '../../config/theme';

const style = {
	inputCtrl: {
		width: '100%',
		padding: '7px 15px'
	},
	topSpace: {
		marginTop: '30px'
	},
	error: {
		color: 'red'
	},
	setColor: {
		color: primaryColor
	},
	msg: {
		fontWeight: 500,
		color: textBlack,
		textTransform: 'none',
		fontFamily: webFont,
	},
	setFont: {
		fontFamily: webFont
	},
	btnLogin: {
		textTransform: 'none',
		fontFamily: webFont,
		fontWeight: 500,
		borderRadius: '35px'
	},
	btnRegister: {
		color: fontColor
	},
	errGrid: {
		width: '100%',
		alignItems: 'center',
		justify: 'center',
		textAlign: 'center',
		marginBottom: '25px',
		backgroundColor: 'red'
	},
	errGridText: {
		font: webFont,
		color: fontColor
	},
	loginHere: {
		cursor: 'pointer',
		fontStyle: 'italic',
		fontWeight: 600,
		textDecorationStyle: 'dotted',
		textDecorationLine: 'underline'
	}
};

export default style;
